import { DOCUMENT, PlatformLocation } from '@angular/common';
import { Component, ElementRef, Inject, Optional, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { finalize } from 'rxjs/operators';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { DocumentService } from '../../../shared/services/document/document.service';

export class DocumentModalComponentContext {
    constructor(public documentId: number, public document?: any) {}
}

@Component({
    templateUrl: './document-modal.html'
})
export class DocumentModalComponent extends BaseComponent {
    public loading: boolean;
    @ViewChild('docview', { static: true })
    private documentView: ElementRef;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<DocumentModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DocumentModalComponentContext,
        private _documentService: DocumentService,
        @Inject(DOCUMENT) protected browerDocument
    ) {
        super();
        this.loading = true;
        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    public ngOnInit() {

        if (this.data.documentId != null) {
            this._documentService.getDocument(this.data.documentId).pipe(
                finalize(() => this.loading = false))
                .subscribe(d => this.loadDocument(d));
        } else if (this.data.document != null) {
            this.loadDocument(this.data.document);
            this.loading = false;
        }
    }

    public cancel() {
        this.dialogRef.close();
    }

    private loadDocument = (document: any): void => {
        if (null == document) {
            return;
        }

        let byteCharacters;

        if (document.documentContent != null) {
            byteCharacters = atob(document.documentContent);
        } else if (document.file != null) {
            byteCharacters = atob(document.file);
        } else {
            return;
        }

        let byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: 'application/pdf' });
        let fileURL = URL.createObjectURL(file);

        let iframe = this.browerDocument.createElement('iframe');
        iframe.className = 'viewObjectFrameFull';
        iframe.style.cssText = 'width: 100%; height: 500px;';

        iframe.src = fileURL;
        this.documentView.nativeElement.appendChild(iframe);
    };
}
